import React, { useState, useContext } from "react";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import OutlinedInput from "@mui/material/OutlinedInput";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Button from "@mui/material/Button";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { useSnackbar } from "notistack";
import axios from "axios";
import PulseLoader from "react-spinners/PulseLoader";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import EmailIcon from "@mui/icons-material/Email";
import { postDataWithToken } from "../../services/PostDataService";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import { Paper } from "@mui/material";
import { getDataWithToken } from "../../services/GetDataService";
import WebsiteHeader from "../../website-header/WebsiteHeader";
import WebsiteFooter from "../../website-footer/WebsiteFooter";
const useStyles = makeStyles((theme) => ({
  form: {
    padding: "80px 100px",
    // background: "#fff",
    // borderRadius: "10px",
    textAlign: "center",
    width: "550px",
    boxSizing: "border-box",
    // boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
    [theme.breakpoints.down("sm")]: {
      width: "100% !important",
      padding: "40px 40px",
    },
  },
  customInput: {
    "& label.Mui-focused": {
      color: "#A0AAB4",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "none",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#E0E3E7",
      },
      "&:hover fieldset": {
        borderColor: "none",
      },
      "&.Mui-focused fieldset": {
        borderColor: "none",
        border: "none",
      },
    },
  },
  input: {
    // @ts-ignore

    background: "#E5FFFD",
    borderRadius: "4px",

    "& fieldset": { border: "none" },
    input: {
      color: "#000",
      fontWeight: 500,
    },
  },
  button: {
    borderRadius: 0,
    marginTop: 16,
  },
}));

const Login = () => {
  const classes = useStyles();
  const theme = useTheme();
  const navigate = useNavigate();

  const { login, admin_panel_user, logout } = useContext(AuthContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const validation = () => {
    let isError = false;
    if (!email.trim()) {
      handleSnakbarOpen("Please enter email address", "error");
      document.getElementById("email").focus();
      return (isError = true);
    } else if (
      !/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        email.trim()
      )
    ) {
      handleSnakbarOpen("Invalid email address", "error");
      document.getElementById("email").focus();
      return (isError = true);
    }

    if (!password.trim()) {
      handleSnakbarOpen("Please enter password", "error");
      document.getElementById("password").focus();
      return (isError = true);
    }
    return isError;
  };

  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === "error") {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    let err = validation();
    if (err) {
      return;
    } else {
      setLoading(true);

      let data = {
        email: email.trim(),
        password: password.trim(),
      };
      let response = await postDataWithToken(
        "login",
        data,
        admin_panel_user,
        logout
      );
      console.log("response", response.data);
      if (response.data.code === 200) {
        handleSnakbarOpen(response.data.message, "success");
        let stores = await getDataWithToken(
          "getStoreInformation",
          response.data.data,
          logout
        );
        console.log("stores login page", stores.data);
        if (stores.data.status) {
          login({
            ...response.data.data,
            stores: stores.data.data.storeInfo,
            selectedStoreId: stores.data.data.storeInfo[0].id,
            selectedStoreName: stores.data.data.storeInfo[0].storeName,
          });
        } else {
          login({
            ...response.data.data,
            stores: [],
            selectedStoreId: "",
            selectedStoreName: "",
          });
        }
        navigate("/dashboard");
      } else {
        handleSnakbarOpen(response.data.message, "error");
      }

      setLoading(false);
    }
  };
  return (
    <React.Fragment>
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-between",
          background: "#e7fffd",
        }}
      >
        <WebsiteHeader />
        <Paper sx={{ width: { xs: "90%", sm: "auto" } }}>
          <form className={classes.form} onSubmit={onSubmit}>
            <img
              src={
                theme.palette.mode === "light"
                  ? "/images/Logo.png"
                  : "/images/Logo_Dark.png"
              }
              alt=""
              style={{ display: "block", margin: "auto" }}
            />
            <br />
            <Typography
              variant="h5"
              component="div"
              style={{ marginBottom: "20px", color: "#016363" }}
            >
              Sign-In to continue{" "}
            </Typography>
            <TextField
              autoFocus
              placeholder="Enter your email address"
              fullWidth
              // size="small"
              // className={classes.customInput}
              style={{ marginBottom: "30px" }}
              InputProps={{
                className: classes.input,
                startAdornment: (
                  <InputAdornment position="start">
                    <EmailOutlinedIcon />
                  </InputAdornment>
                ),
              }}
              variant="outlined"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <FormControl
              fullWidth
              variant="outlined"
              style={{ marginBottom: "30px" }}
              className={classes.input}
            >
              <OutlinedInput
                type={showPassword ? "text" : "password"}
                id="password"
                placeholder="Enter your password"
                // size="small"

                value={password}
                onChange={(e) => setPassword(e.target.value)}
                startAdornment={
                  <InputAdornment position="start">
                    <LockOutlinedIcon />
                  </InputAdornment>
                }
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => setShowPassword(!showPassword)}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? (
                        <VisibilityOffOutlinedIcon />
                      ) : (
                        <VisibilityOutlinedIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>

            <Grid container alignItems="center" style={{ marginBottom: "20px" }}>
              <Grid item xs={12}>
                <FormGroup>
                  <FormControlLabel
                    control={<Checkbox defaultChecked />}
                    label="Remember me"
                  />
                </FormGroup>
              </Grid>
            </Grid>

            <Button
              variant="contained"
              disableElevation
              fullWidth
              style={{ marginBottom: "20px", minHeight: "55px" }}
              disabled={loading}
              // onClick={onSubmit}
              type="submit"
              className={classes.button}
            >
              {loading === false && "Continue"}
              <PulseLoader
                // color={"#353b48"}
                color={theme.palette.primary.main}
                loading={loading}
                size={10}
                speedMultiplier={0.5}
              />{" "}
            </Button>
            
            <Button
              variant="outlined"
              disableElevation
              fullWidth
              style={{ 
                marginBottom: "30px", 
                minHeight: "55px",
                borderColor: "#016363",
                color: "#016363",
                "&:hover": {
                  borderColor: "#016363",
                  backgroundColor: "rgba(1, 99, 99, 0.04)"
                }
              }}
              onClick={() => navigate("/register")}
              className={classes.button}
            >
              Don't have an account? Sign Up
            </Button>
          </form>
        </Paper>
        <WebsiteFooter />
      </div>
    </React.Fragment>
  );
};

export default Login;
